// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2W2wE","consentsList":"PatientConsents_consentsList__t9acI","consentsListEmpty":"PatientConsents_consentsListEmpty__2FFdo"};